export const PROJECT_TABS = [
    { value: "subprojects", label: "Subproyectos" },
    { value: "steps", label: "Pasos" },
    { value: "trello", label: "Trello" },
    { value: "runbooks", label: "Runbooks" },
    { value: "credentials", label: "Credenciales" },
    { value: "links", label: "Enlaces" },
    { value: "info", label: "Ficha" },
    { value: "health", label: "Salud" },
    { value: "guides", label: "Guías" },
];

export const SUBPROJECT_TABS = [
    { value: "logbook", label: "Bitácora" },
    { value: "drafts", label: "Borrador" },
    { value: "changes", label: "Cambios" },
    { value: "tasks", label: "Tareas" },
    { value: "environments", label: "Entornos" },
    { value: "scripts", label: "Scripts" },
    { value: "steps", label: "Pasos" },
    { value: "files", label: "Archivos" },
    { value: "readme", label: "Readme" },
    { value: "guides", label: "Guías" },
];
